import {I18nKeys} from '@multipass-i18n';
import {FileText, LucideIcon, Shield} from 'lucide-react';

import {I18nKey} from '../../logic';

export const titleKeyFor = (type: string | null): I18nKey =>
    type === 'terms' ? I18nKeys.legal.termsConditions
        : type === 'privacy' ? I18nKeys.common.privacyPolicy
            : I18nKeys.legal.documentFallback;

export const iconFor = (type: string): LucideIcon => (type === 'privacy' ? Shield : FileText);

export const formatEffectiveFrom = (effectiveFrom: string, locale: string): string =>
    new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'long', year: 'numeric'}).format(new Date(effectiveFrom));

export const toParagraphs = (body: string): string[] => body.split(/\n{2,}/).filter(part => part.trim().length > 0);
